import { useAuth0 } from '@auth0/auth0-react';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import accountIcon from '../assets/icons/account_icon.svg';
import cameraIcon from '../assets/icons/camera_icon.svg';
import searchIcon from '../assets/icons/search_icon.svg';
import wolishoLogo from '../assets/logos/wolisho.svg';
import wolishoLogoSmall from '../assets/logos/wolisho_w.svg';

import { SearchBar } from './search/SearchBar';
import { SearchOverlay } from './search/SearchOverlay';

function CameraButton() {
  return (
    <button
      type="button"
      className="flex h-10 w-10 items-center justify-center rounded-lg bg-wolisho-brown"
      aria-label="Camera search"
    >
      <img src={cameraIcon} alt="" className="h-5 w-5" />
    </button>
  );
}

export function Header() {
  const [isMobileSearchOpen, setMobileSearchOpen] = useState(false);
  const location = useLocation();
  const { isAuthenticated } = useAuth0();
  const isAccountActive = location.pathname === '/me';

  // SearchBar fires authenticated GraphQL requests via useSearchCoffees,
  // and the Account link routes to /me which requires a session. When
  // the user isn't signed in (SignedOutLanding, NotInvitedScreen, the
  // Auth0-error variants of RequireAuth) we render only the logo so
  // those interactions don't trigger spurious loginWithRedirect bounces
  // or land the user on a page they can't see.
  return (
    <>
      <header className="bg-wolisho-red px-4 py-3 md:px-8 md:py-4">
        <div className="mx-auto flex max-w-7xl items-center justify-between">
          {/* Logo */}
          <Link to="/" className="shrink-0">
            {/* Compact logo: visible below 450px */}
            <img
              src={wolishoLogoSmall}
              alt=""
              className="block h-12 w-auto min-[450px]:hidden"
            />
            {/* Full logo: visible at 450px+ */}
            <img
              src={wolishoLogo}
              alt="Wolisho"
              className="hidden h-12 w-auto min-[450px]:block md:h-11"
            />
          </Link>

          {isAuthenticated && (
            <>
              {/* Desktop Search Bar */}
              <div className="hidden flex-1 justify-center px-8 md:flex">
                <div className="flex w-full max-w-md items-center gap-1">
                  <SearchBar className="flex-1" />
                  <CameraButton />
                </div>
              </div>

              {/* Mobile Icons */}
              <div className="flex items-center gap-2 md:hidden">
                <button
                  type="button"
                  onClick={() => {
                    setMobileSearchOpen(true);
                  }}
                  className="flex h-10 w-10 items-center justify-center rounded-lg bg-wolisho-brown"
                  aria-label="Search"
                >
                  <img src={searchIcon} alt="" className="h-5 w-5" />
                </button>
                <CameraButton />
              </div>

              {/* Account Link */}
              <Link
                to="/me"
                className={`ml-4 shrink-0 rounded-full transition-opacity ${isAccountActive ? 'opacity-100' : 'opacity-75 hover:opacity-100'}`}
                aria-label="Account"
              >
                <img
                  src={accountIcon}
                  alt=""
                  className="h-10 w-10 md:h-12 md:w-12"
                />
              </Link>
            </>
          )}
        </div>
      </header>

      {isMobileSearchOpen && (
        <SearchOverlay
          onClose={() => {
            setMobileSearchOpen(false);
          }}
        />
      )}
    </>
  );
}
